export const breakpoints = {
  mobile: 375,
  tabletPortrait: 640,
  tabletLandscape: 960,
  desktop: 1024,
};

export const transitions = {
  standard: "all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  deceleration: "all 250ms cubic-bezier(0, 0, 0.2, 1) 0ms",
  acceleration: "all 250ms cubic-bezier(0.4, 0, 1, 1) 0ms",
};

export const zIndices = {
  none: 0,
  low: 1,
  mid: 2,
  high: 3,
};

export const colors = {
  coreGreenL5: "#E9F8EF",
  coreGreenL4: "#BCEBCE",
  coreGreenL3: "#7FD9A1",
  coreGreenL2: "#31C268",
  coreGreenL1: "#1BB152",
  coreGreen: "#128000",
  coreGreenD1: "#00732C",
  coreGreenD2: "#005D23",
  coreGreenD3: "#00491C",
  coreGreenD4: "#002E11",
  coreBlueL5: "#EAF4FF",
  coreBlueL4: "#C8E2FF",
  coreBlueL3: "#99CAFF",
  coreBlueL2: "#64AEFF",
  coreBlueL1: "#2B90FF",
  coreBlue: "#0070EB",
  coreBlueD1: "#005FC8",
  coreBlueD2: "#004EA3",
  coreBlueD3: "#003D81",
  coreBlueD4: "#002650",
  coreNavyL5: "#EBF2FA",
  coreNavyL4: "#C6D3E1",
  coreNavyL3: "#9CB1CB",
  coreNavyL2: "#819CBB",
  coreNavyL1: "#6682A2",
  coreNavy: "#184C8B",
  coreNavyD1: "#14417A",
  coreNavyD2: "#103469",
  coreNavyD3: "#05285A",
  coreNavyD4: "#011638",
  coreRedL5: "#FDECED",
  coreRedL4: "#F9C9CE",
  coreRedL3: "#F198A1",
  coreRedL2: "#EA6875",
  coreRedL1: "#EB4758",
  coreRed: "#D22839",
  coreRedD1: "#C8002B",
  coreRedD2: "#A40023",
  coreRedD3: "#83001C",
  coreRedD4: "#40020D",
  coreOrangeL5: "#FFF1E6",
  coreOrangeL4: "#FFD8B9",
  coreOrangeL3: "#FFB77E",
  coreOrangeL2: "#FF8C31",
  coreOrangeL1: "#F87A1E",
  coreOrange: "#C15400",
  coreOrangeD1: "#A44800",
  coreOrangeD2: "#843B00",
  coreOrangeD3: "#692E00",
  coreOrangeD4: "#401D00",
  coreYellowL5: "#FFF6BD",
  coreYellowL4: "#FFDC2E",
  coreYellowL3: "#EAC300",
  coreYellowL2: "#C9A800",
  coreYellowL1: "#A98E00",
  coreYellow: "#8A7000",
  coreYellowD1: "#756100",
  coreYellowD2: "#5F4F00",
  coreYellowD3: "#4B3F00",
  coreYellowD4: "#2E2600",
  corePurpleL5: "#F6F1FE",
  corePurpleL4: "#E6D6FE",
  corePurpleL3: "#D4B6FE",
  corePurpleL2: "#C18FFE",
  corePurpleL1: "#B265FE",
  corePurple: "#A530F3",
  corePurpleD1: "#8F02E1",
  corePurpleD2: "#7401B7",
  corePurpleD3: "#61019B",
  corePurpleD4: "#36005B",
  coreTealL5: "#D4FAF2",
  coreTealL4: "#9CF7E4",
  coreTealL3: "#75EBD2",
  coreTealL2: "#00E5B4",
  coreTealL1: "#00C898",
  coreTeal: "#008568",
  coreTealD1: "#00735A",
  coreTealD2: "#005F48",
  coreTealD3: "#004435",
  coreTealD4: "#003328",
  coreWhite: "#ffffff",
  coreGreyL5: "#F7FBFF",
  coreGreyL4: "#EAF0F6",
  coreGreyL3: "#CED4DB",
  coreGreyL2: "#B0B7BF",
  coreGreyL1: "#969DA3",
  coreGrey: "#6A6F73",
  coreGreyD1: "#4D5153",
  coreGreyD2: "#3C3E40",
  coreGreyD3: "#2B2D2E",
  coreGreyD4: "#1C1D1D",
  coreBlack: "#0a0a0a",
  coreBlackTint005: "#0a0a0a0d",
  coreBlackTint010: "#0a0a0a1a",
  coreBlackTint020: "#0a0a0a33",
  coreBlackTint030: "#0a0a0a4d",
  coreBlackTint040: "#0a0a0a66",
  coreBlackTint050: "#0a0a0a80",
  coreBlackTint060: "#0a0a0a99",
  coreBlackTint070: "#0a0a0ab3",
  coreBlackTint080: "#0a0a0acc",
  coreBlackTint090: "#0a0a0ae6",
  coreWhiteTint005: "#ffffff0d",
  coreWhiteTint010: "#ffffff1a",
  coreWhiteTint020: "#ffffff33",
  coreWhiteTint030: "#ffffff4d",
  coreWhiteTint040: "#ffffff66",
  coreWhiteTint050: "#ffffff80",
  coreWhiteTint060: "#ffffff99",
  coreWhiteTint070: "#ffffffb3",
  coreWhiteTint080: "#ffffffcc",
  coreWhiteTint090: "#ffffffe6",
  coreTransparentWhite: "#ffffff00",
  coreTransparentBlack: "#0a0a0a00",
  productGradientsSports: "linear-gradient(125deg, #005FC8 0%, #003D81 100%)",
  productGradientsCasino: "linear-gradient(125deg, #61019B 0%, #005FC8 100%)",
  productGradientsFaceoff: "linear-gradient(125deg, #00E5B4 0%, #0070EB 100%)",
  brandPrimaryDefault: "#0070EB",
  brandPrimaryTint: "#C8E2FF",
  brandPrimaryShade: "#004EA3",
  brandSecondaryDefault: "#184C8B",
  brandSecondaryTint: "#C6D3E1",
  brandSecondaryShade: "#011638",
  brandTertiaryDefault: "#FFDC2E",
  brandTertiaryTint: "#FFF8D9",
  brandTertiaryShade: "#D78027",
  brandGradientDefault: "linear-gradient(125deg, #005FC8 0%, #003D81 100%)",
  brandGradientColorStopsStart: "#005FC8",
  brandGradientColorStopsEnd: "#003D81",
  productColorsPrimaryL5: "#EAF4FF",
  productColorsPrimaryL4: "#C8E2FF",
  productColorsPrimaryL3: "#99CAFF",
  productColorsPrimaryL2: "#64AEFF",
  productColorsPrimaryL1: "#2B90FF",
  productColorsPrimary: "#0070EB",
  productColorsPrimaryD1: "#005FC8",
  productColorsPrimaryD2: "#004EA3",
  productColorsPrimaryD3: "#003D81",
  productColorsPrimaryD4: "#002650",
  productColorsSecondaryL5: "#EBF2FA",
  productColorsSecondaryL4: "#C6D3E1",
  productColorsSecondaryL3: "#9CB1CB",
  productColorsSecondaryL2: "#819CBB",
  productColorsSecondaryL1: "#6682A2",
  productColorsSecondary: "#184C8B",
  productColorsSecondaryD1: "#14417A",
  productColorsSecondaryD2: "#103469",
  productColorsSecondaryD3: "#05285A",
  productColorsSecondaryD4: "#011638",
  productColorsTertiaryL5: "#FFFBEC",
  productColorsTertiaryL4: "#FFF8D9",
  productColorsTertiaryL3: "#FFF4C6",
  productColorsTertiaryL2: "#FFF1B3",
  productColorsTertiaryL1: "#FFEDA0",
  productColorsTertiary: "#FFDC2E",
  productColorsTertiaryD1: "#F8C429",
  productColorsTertiaryD2: "#EFAC27",
  productColorsTertiaryD3: "#E49627",
  productColorsTertiaryD4: "#D78027",
  contentStrong: "#05285A",
  contentDefault: "#1C1D1D",
  contentSubtle: "#6A6F73",
  contentDisabled: "#0a0a0a33",
  contentOnLight: "#05285A",
  contentOnDark: "#ffffff",
  contentBrandPrimary: "#0070EB",
  contentBrandSecondary: "#184C8B",
  contentLoadingDefault: "#0a0a0a0d",
  contentLoadingInverse: "#ffffff1a",
  contentLink: "#0070EB",
  contentLinkActive: "#004EA3",
  backgroundBase: "#EAF0F6",
  backgroundSurface: "#ffffff",
  backgroundLayer: "#F7FBFF",
  backgroundAccent: "#0a0a0a0d",
  backgroundHover: "#EAF4FF",
  backgroundActive: "#0070EB",
  backgroundDisabled: "#EAF0F6",
  backgroundTransparent: "#ffffff00",
  backgroundPrimary: "#0070EB",
  backgroundSecondary: "#184C8B",
  backgroundPromotional: "#011638",
  backgroundBrand: "#0070EB",
  backgroundGradientSurfaceFadeEnd: "linear-gradient(90deg, #ffffff00 0%, #ffffff 100%)",
  backgroundGradientSurfaceFadeBottom: "linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)",
  backgroundGradientColorStopsStart: "#ffffff00",
  backgroundGradientColorStopsEnd: "#ffffff",
  borderDefault: "#B0B7BF",
  borderSubtle: "#C6D3E1",
  borderActive: "#0070EB",
  borderDisabled: "#0a0a0a1a",
  borderInverse: "#ffffff",
  borderBrand: "#0070EB",
  linkDefaultBase: "#0070EB",
  linkDefaultHover: "#004EA3",
  linkDestructiveBase: "#D22839",
  linkDestructiveHover: "#A40023",
  linkInverseDefaultBase: "#ffffff",
  linkInverseDefaultHover: "#C8E2FF",
  linkInverseDestructiveBase: "#EA6875",
  linkInverseDestructiveHover: "#D22839",
  systemInfoBackgroundDefault: "#005FC8",
  systemInfoBackgroundSubtle: "#EAF4FF",
  systemInfoBorderDefault: "#005FC8",
  systemInfoContentOnDefault: "#ffffff",
  systemInfoContentOnSubtle: "#05285A",
  systemInfoContentAccent: "#004EA3",
  systemInfoLinkOnDefault: "#ffffff",
  systemInfoLinkOnSubtle: "#0070EB",
  systemPositiveBackgroundDefault: "#128000",
  systemPositiveBackgroundSubtle: "#E9F8EF",
  systemPositiveBorderDefault: "#128000",
  systemPositiveContentOnDefault: "#ffffff",
  systemPositiveContentOnSubtle: "#05285A",
  systemPositiveContentAccent: "#00732C",
  systemPositiveLinkOnDefault: "#ffffff",
  systemPositiveLinkOnSubtle: "#0070EB",
  systemAlertBackgroundDefault: "#FFDC2E",
  systemAlertBackgroundSubtle: "#FFF6BD",
  systemAlertBorderDefault: "#FFDC2E",
  systemAlertContentOnDefault: "#05285A",
  systemAlertContentOnSubtle: "#05285A",
  systemAlertContentAccent: "#756100",
  systemAlertLinkOnDefault: "#05285A",
  systemAlertLinkOnSubtle: "#0070EB",
  systemWarningBackgroundDefault: "#FF8C31",
  systemWarningBackgroundSubtle: "#FFF1E6",
  systemWarningBorderDefault: "#FF8C31",
  systemWarningContentOnDefault: "#05285A",
  systemWarningContentOnSubtle: "#05285A",
  systemWarningContentAccent: "#A44800",
  systemWarningLinkOnDefault: "#05285A",
  systemWarningLinkOnSubtle: "#0070EB",
  systemImportantBackgroundDefault: "#D22839",
  systemImportantBackgroundSubtle: "#FDECED",
  systemImportantBorderDefault: "#D22839",
  systemImportantContentOnDefault: "#ffffff",
  systemImportantContentOnSubtle: "#05285A",
  systemImportantContentAccent: "#C8002B",
  systemImportantLinkOnDefault: "#ffffff",
  systemImportantLinkOnSubtle: "#0070EB",
  systemNeutralBackgroundDefault: "#B0B7BF",
  systemNeutralBackgroundSubtle: "#EAF0F6",
  systemNeutralBorderDefault: "#B0B7BF",
  systemNeutralContentOnDefault: "#05285A",
  systemNeutralContentOnSubtle: "#05285A",
  systemNeutralContentAccent: "#6A6F73",
  systemNeutralLinkOnDefault: "#05285A",
  systemNeutralLinkOnSubtle: "#0070EB",
  systemVerificationBackgroundDefault: "#8F02E1",
  systemVerificationBackgroundSubtle: "#F6F1FE",
  systemVerificationBorderDefault: "#8F02E1",
  systemVerificationContentOnDefault: "#ffffff",
  systemVerificationContentOnSubtle: "#05285A",
  systemVerificationContentAccent: "#7401B7",
  systemVerificationLinkOnDefault: "#ffffff",
  systemVerificationLinkOnSubtle: "#0070EB",
  componentButtonPrimaryContentBase: "#ffffff",
  componentButtonPrimaryContentHover: "#ffffff",
  componentButtonPrimaryContentActive: "#ffffff",
  componentButtonPrimaryContentDisabled: "#0a0a0a33",
  componentButtonPrimaryBackgroundBase: "#128000",
  componentButtonPrimaryBackgroundHover: "#00732C",
  componentButtonPrimaryBackgroundActive: "#005D23",
  componentButtonPrimaryBackgroundDisabled: "#EAF0F6",
  componentButtonPrimaryBorderBase: "#128000",
  componentButtonPrimaryBorderHover: "#00732C",
  componentButtonPrimaryBorderActive: "#005D23",
  componentButtonPrimaryBorderDisabled: "#0a0a0a1a",
  componentButtonSecondaryContentBase: "#ffffff",
  componentButtonSecondaryContentHover: "#ffffff",
  componentButtonSecondaryContentActive: "#ffffff",
  componentButtonSecondaryContentDisabled: "#0a0a0a33",
  componentButtonSecondaryBackgroundBase: "#0070EB",
  componentButtonSecondaryBackgroundHover: "#005FC8",
  componentButtonSecondaryBackgroundActive: "#004EA3",
  componentButtonSecondaryBackgroundDisabled: "#EAF0F6",
  componentButtonSecondaryBorderBase: "#0070EB",
  componentButtonSecondaryBorderHover: "#005FC8",
  componentButtonSecondaryBorderActive: "#004EA3",
  componentButtonSecondaryBorderDisabled: "#0a0a0a1a",
  componentButtonTertiaryContentBase: "#0070EB",
  componentButtonTertiaryContentHover: "#0070EB",
  componentButtonTertiaryContentActive: "#ffffff",
  componentButtonTertiaryContentDisabled: "#0a0a0a33",
  componentButtonTertiaryBackgroundBase: "#ffffff00",
  componentButtonTertiaryBackgroundHover: "#EAF4FF",
  componentButtonTertiaryBackgroundActive: "#0070EB",
  componentButtonTertiaryBackgroundDisabled: "#ffffff00",
  componentButtonTertiaryBorderBase: "#0070EB",
  componentButtonTertiaryBorderHover: "#0070EB",
  componentButtonTertiaryBorderActive: "#0070EB",
  componentButtonTertiaryBorderDisabled: "#0a0a0a1a",
  componentButtonTransparentContentBase: "#ffffff",
  componentButtonTransparentContentHover: "#ffffff",
  componentButtonTransparentContentActive: "#ffffff",
  componentButtonTransparentContentDisabled: "#ffffff33",
  componentButtonTransparentBackgroundBase: "#ffffff00",
  componentButtonTransparentBackgroundHover: "#ffffff1a",
  componentButtonTransparentBackgroundActive: "#0070EB",
  componentButtonTransparentBackgroundDisabled: "#ffffff00",
  componentButtonTransparentBorderBase: "#ffffff",
  componentButtonTransparentBorderHover: "#ffffff",
  componentButtonTransparentBorderActive: "#ffffff00",
  componentButtonTransparentBorderDisabled: "#ffffff33",
  componentButtonDestructiveContentBase: "#ffffff",
  componentButtonDestructiveContentHover: "#ffffff",
  componentButtonDestructiveContentActive: "#ffffff",
  componentButtonDestructiveContentDisabled: "#0a0a0a33",
  componentButtonDestructiveBackgroundBase: "#D22839",
  componentButtonDestructiveBackgroundHover: "#C8002B",
  componentButtonDestructiveBackgroundActive: "#A40023",
  componentButtonDestructiveBackgroundDisabled: "#EAF0F6",
  componentButtonDestructiveBorderBase: "#D22839",
  componentButtonDestructiveBorderHover: "#C8002B",
  componentButtonDestructiveBorderActive: "#A40023",
  componentButtonDestructiveBorderDisabled: "#0a0a0a1a",
  componentButtonButtonLinkContentBase: "#0070EB",
  componentButtonButtonLinkContentHover: "#004EA3",
  componentButtonButtonLinkContentActive: "#ffffff",
  componentButtonButtonLinkContentDisabled: "#0a0a0a33",
  componentButtonButtonLinkBackgroundBase: "#ffffff00",
  componentButtonButtonLinkBackgroundHover: "#EAF4FF",
  componentButtonButtonLinkBackgroundActive: "#005FC8",
  componentButtonButtonLinkBackgroundDisabled: "#ffffff00",
  componentButtonButtonLinkBorderBase: "#ffffff00",
  componentButtonButtonLinkBorderHover: "#ffffff00",
  componentButtonButtonLinkBorderActive: "#ffffff00",
  componentButtonButtonLinkBorderDisabled: "#0a0a0a1a",
  componentSelectionControlBackgroundBase: "#ffffff",
  componentSelectionControlBackgroundHover: "#EAF4FF",
  componentSelectionControlBackgroundActive: "#0070EB",
  componentSelectionControlBackgroundSelected: "#005FC8",
  componentSelectionControlBackgroundSelectedHover: "#004EA3",
  componentSelectionControlBackgroundSelectedActive: "#004EA3",
  componentSelectionControlBackgroundUnselected: "#CED4DB",
  componentSelectionControlBackgroundDisabled: "#EAF0F6",
  componentSelectionControlBackgroundSuccess: "#128000",
  componentSelectionControlBackgroundError: "#D22839",
  componentSelectionControlBorderBase: "#B0B7BF",
  componentSelectionControlBorderHover: "#0070EB",
  componentSelectionControlBorderActive: "#0070EB",
  componentSelectionControlBorderSelected: "#005FC8",
  componentSelectionControlBorderSelectedHover: "#004EA3",
  componentSelectionControlBorderSelectedActive: "#004EA3",
  componentSelectionControlBorderUnselected: "#CED4DB",
  componentSelectionControlBorderDisabled: "#0a0a0a1a",
  componentSelectionControlBorderSuccess: "#128000",
  componentSelectionControlBorderError: "#D22839",
  componentSelectionControlForegroundBase: "#ffffff00",
  componentSelectionControlForegroundHover: "#ffffff00",
  componentSelectionControlForegroundActive: "#0070EB",
  componentSelectionControlForegroundSelected: "#ffffff",
  componentSelectionControlForegroundSelectedHover: "#ffffff",
  componentSelectionControlForegroundSelectedActive: "#ffffff",
  componentSelectionControlForegroundUnselected: "#ffffff00",
  componentSelectionControlForegroundDisabled: "#0a0a0a33",
  componentSelectionControlForegroundSuccess: "#ffffff",
  componentSelectionControlForegroundError: "#ffffff",
  componentDataInputBackgroundBase: "#ffffff",
  componentDataInputBackgroundLayer: "#F7FBFF",
  componentDataInputBackgroundHover: "#EAF4FF",
  componentDataInputBackgroundError: "#FDECED",
  componentDataInputBackgroundDisabled: "#EAF0F6",
  componentDataInputBorderBase: "#B0B7BF",
  componentDataInputBorderActive: "#005FC8",
  componentDataInputBorderError: "#D22839",
  componentDataInputBorderDisabled: "#0a0a0a1a",
  componentDataInputContentBase: "#1C1D1D",
  componentDataInputContentSubtle: "#6A6F73",
  componentDataInputContentHover: "#004EA3",
  componentDataInputContentError: "#C8002B",
  componentDataInputContentDisabled: "#0a0a0a33",
  componentDataInputLabelBase: "#05285A",
  componentDataInputLabelActive: "#004EA3",
  componentDataInputLabelError: "#C8002B",
  componentDataInputLabelDisabled: "#0a0a0a33",
  componentDataInputPasswordMeterEmpty: "#B0B7BF",
  componentDataInputPasswordMeterWeak: "#D22839",
  componentDataInputPasswordMeterFair: "#FF8C31",
  componentDataInputPasswordMeterGood: "#005FC8",
  componentDataInputPasswordMeterGreat: "#128000",
  componentDataInputIconBase: "#6A6F73",
  componentDataInputIconActive: "#004EA3",
  componentDataInputIconError: "#C8002B",
  componentDataInputIconDisabled: "#0a0a0a33",
  componentPillPrimaryContentBase: "#011638",
  componentPillPrimaryContentHover: "#011638",
  componentPillPrimaryContentSelected: "#ffffff",
  componentPillPrimaryContentActive: "#ffffff",
  componentPillPrimaryContentDisabled: "#B0B7BF",
  componentPillPrimaryBackgroundBase: "#EAF0F6",
  componentPillPrimaryBackgroundHover: "#CED4DB",
  componentPillPrimaryBackgroundSelected: "#0070EB",
  componentPillPrimaryBackgroundActive: "#005FC8",
  componentPillPrimaryBackgroundDisabled: "#EAF0F6",
  componentPillInverseContentBase: "#ffffff",
  componentPillInverseContentHover: "#011638",
  componentPillInverseContentSelected: "#ffffff",
  componentPillInverseContentActive: "#ffffff",
  componentPillInverseContentDisabled: "#B0B7BF",
  componentPillInverseBackgroundBase: "#ffffff00",
  componentPillInverseBackgroundHover: "#CED4DB",
  componentPillInverseBackgroundSelected: "#0070EB",
  componentPillInverseBackgroundActive: "#005FC8",
  componentPillInverseBackgroundDisabled: "#EAF0F6",
  componentTabPrimaryLabelBase: "#05285A",
  componentTabPrimaryLabelHover: "#004EA3",
  componentTabPrimaryLabelActive: "#0070EB",
  componentTabPrimaryDescriptionBase: "#6A6F73",
  componentTabPrimaryDescriptionHover: "#6A6F73",
  componentTabPrimaryDescriptionActive: "#6A6F73",
  componentTabPrimaryIndicatorBase: "#ffffff00",
  componentTabPrimaryIndicatorHover: "#004EA3",
  componentTabPrimaryIndicatorActive: "#0070EB",
  componentTabPrimaryBackgroundBase: "#ffffff00",
  componentTabPrimaryBackgroundHover: "#ffffff00",
  componentTabPrimaryBackgroundActive: "#ffffff00",
  componentTabPrimaryIconBase: "#05285A",
  componentTabPrimaryIconHover: "#004EA3",
  componentTabPrimaryIconActive: "#0070EB",
  componentTabInverseLabelBase: "#ffffff",
  componentTabInverseLabelHover: "#ffffff",
  componentTabInverseLabelActive: "#ffffff",
  componentTabInverseDescriptionBase: "#ffffff",
  componentTabInverseDescriptionHover: "#ffffff",
  componentTabInverseDescriptionActive: "#ffffff",
  componentTabInverseIndicatorBase: "#ffffff00",
  componentTabInverseIndicatorHover: "#ffffff",
  componentTabInverseIndicatorActive: "#ffffff",
  componentTabInverseBackgroundBase: "#ffffff00",
  componentTabInverseBackgroundHover: "#ffffff00",
  componentTabInverseBackgroundActive: "#ffffff00",
  componentTabInverseIconBase: "#ffffff",
  componentTabInverseIconHover: "#ffffff",
  componentTabInverseIconActive: "#ffffff",
};

export const fonts = {
  fontFamily010: "Proxima Nova",
  fontFamily020: "Shentox",
  fontFamily030: "Proxima Nova Condensed",
  fontFamily040: "Inter",
  fontFamily050: "Roboto Condensed",
  jumboXxLarge: "Proxima Nova",
  jumboXLarge: "Proxima Nova",
  jumboLarge: "Proxima Nova",
  jumboMedium: "Proxima Nova",
  jumboSmall: "Proxima Nova",
  headingXxLarge: "Proxima Nova",
  headingXLarge: "Proxima Nova",
  headingLarge: "Proxima Nova",
  headingMedium: "Proxima Nova",
  headingSmall: "Proxima Nova",
  headingXSmall: "Proxima Nova",
  bodyXLargeRegular: "Proxima Nova",
  bodyXLargeStrong: "Proxima Nova",
  bodyXLargeRegularStrikethrough: "Proxima Nova",
  bodyXLargeStrongStrikethrough: "Proxima Nova",
  bodyLargeRegular: "Proxima Nova",
  bodyLargeStrong: "Proxima Nova",
  bodyLargeRegularStrikethrough: "Proxima Nova",
  bodyLargeStrongStrikethrough: "Proxima Nova",
  bodyMediumRegular: "Proxima Nova",
  bodyMediumStrong: "Proxima Nova",
  bodyMediumRegularStrikethrough: "Proxima Nova",
  bodyMediumStrongStrikethrough: "Proxima Nova",
  bodySmallRegular: "Proxima Nova",
  bodySmallStrong: "Proxima Nova",
  bodySmallRegularStrikethrough: "Proxima Nova",
  bodySmallStrongStrikethrough: "Proxima Nova",
  bodyXSmallRegular: "Proxima Nova",
  bodyXSmallStrong: "Proxima Nova",
  bodyXSmallRegularStrikethrough: "Proxima Nova",
  bodyXSmallStrongStrikethrough: "Proxima Nova",
  buttonLargeRegular: "Proxima Nova",
  buttonLargeStrong: "Proxima Nova",
  buttonMediumRegular: "Proxima Nova",
  buttonMediumStrong: "Proxima Nova",
  buttonSmallRegular: "Proxima Nova",
  buttonSmallStrong: "Proxima Nova",
  buttonXSmallRegular: "Proxima Nova",
  buttonXSmallStrong: "Proxima Nova",
  metadataMedium: "Proxima Nova Condensed",
  metadataSmall: "Proxima Nova Condensed",
  labelXLarge: "Proxima Nova Condensed",
  labelLarge: "Proxima Nova Condensed",
  labelMedium: "Proxima Nova Condensed",
  labelSmall: "Proxima Nova Condensed",
  labelXSmall: "Proxima Nova Condensed",
};

export const fontWeights = {
  fontWeight010: "300",
  fontWeight020: "400",
  fontWeight030: "500",
  fontWeight040: "600",
  fontWeight050: "700",
  fontWeight060: "700",
  fontWeight070: "800",
  fontWeight080: "800",
  fontWeight090: "900",
  jumboXxLarge: "700",
  jumboXLarge: "700",
  jumboLarge: "700",
  jumboMedium: "700",
  jumboSmall: "700",
  headingXxLarge: "700",
  headingXLarge: "700",
  headingLarge: "700",
  headingMedium: "700",
  headingSmall: "700",
  headingXSmall: "700",
  bodyXLargeRegular: "400",
  bodyXLargeStrong: "700",
  bodyXLargeRegularStrikethrough: "400",
  bodyXLargeStrongStrikethrough: "700",
  bodyLargeRegular: "400",
  bodyLargeStrong: "700",
  bodyLargeRegularStrikethrough: "400",
  bodyLargeStrongStrikethrough: "700",
  bodyMediumRegular: "400",
  bodyMediumStrong: "700",
  bodyMediumRegularStrikethrough: "400",
  bodyMediumStrongStrikethrough: "700",
  bodySmallRegular: "400",
  bodySmallStrong: "700",
  bodySmallRegularStrikethrough: "400",
  bodySmallStrongStrikethrough: "700",
  bodyXSmallRegular: "400",
  bodyXSmallStrong: "700",
  bodyXSmallRegularStrikethrough: "400",
  bodyXSmallStrongStrikethrough: "700",
  buttonLargeRegular: "400",
  buttonLargeStrong: "700",
  buttonMediumRegular: "400",
  buttonMediumStrong: "700",
  buttonSmallRegular: "400",
  buttonSmallStrong: "700",
  buttonXSmallRegular: "400",
  buttonXSmallStrong: "700",
  metadataMedium: "400",
  metadataSmall: "400",
  labelXLarge: "400",
  labelLarge: "400",
  labelMedium: "400",
  labelSmall: "400",
  labelXSmall: "400",
};

export const lineHeights = {
  lineHeight010: 1,
  lineHeight020: 1.1,
  lineHeight030: 1.25,
  lineHeight040: 1.5,
  jumboXxLarge: 1.1,
  jumboXLarge: 1.1,
  jumboLarge: 1.25,
  jumboMedium: 1.25,
  jumboSmall: 1.25,
  headingXxLarge: 1.25,
  headingXLarge: 1.25,
  headingLarge: 1.25,
  headingMedium: 1.25,
  headingSmall: 1.25,
  headingXSmall: 1.25,
  bodyXLargeRegular: 1.25,
  bodyXLargeStrong: 1.25,
  bodyXLargeRegularStrikethrough: 1.25,
  bodyXLargeStrongStrikethrough: 1.25,
  bodyLargeRegular: 1.25,
  bodyLargeStrong: 1.25,
  bodyLargeRegularStrikethrough: 1.25,
  bodyLargeStrongStrikethrough: 1.25,
  bodyMediumRegular: 1.25,
  bodyMediumStrong: 1.25,
  bodyMediumRegularStrikethrough: 1.25,
  bodyMediumStrongStrikethrough: 1.25,
  bodySmallRegular: 1.25,
  bodySmallStrong: 1.25,
  bodySmallRegularStrikethrough: 1.25,
  bodySmallStrongStrikethrough: 1.25,
  bodyXSmallRegular: 1.25,
  bodyXSmallStrong: 1.25,
  bodyXSmallRegularStrikethrough: 1.25,
  bodyXSmallStrongStrikethrough: 1.25,
  buttonLargeRegular: 1.25,
  buttonLargeStrong: 1.25,
  buttonMediumRegular: 1.25,
  buttonMediumStrong: 1.25,
  buttonSmallRegular: 1.25,
  buttonSmallStrong: 1.25,
  buttonXSmallRegular: 1.25,
  buttonXSmallStrong: 1.25,
  metadataMedium: 1.25,
  metadataSmall: 1.25,
  labelXLarge: 1.25,
  labelLarge: 1.25,
  labelMedium: 1.25,
  labelSmall: 1.25,
  labelXSmall: 1.25,
};

export const fontSizes = {
  fontSize010: 8,
  fontSize020: 10,
  fontSize030: 12,
  fontSize040: 14,
  fontSize050: 16,
  fontSize060: 18,
  fontSize070: 20,
  fontSize080: 22,
  fontSize090: 24,
  fontSize100: 28,
  fontSize110: 32,
  fontSize120: 36,
  fontSize130: 40,
  fontSize140: 48,
  fontSize150: 60,
  jumboXxLarge: 48,
  jumboXLarge: 40,
  jumboLarge: 32,
  jumboMedium: 28,
  jumboSmall: 24,
  headingXxLarge: 22,
  headingXLarge: 20,
  headingLarge: 18,
  headingMedium: 16,
  headingSmall: 14,
  headingXSmall: 12,
  bodyXLargeRegular: 18,
  bodyXLargeStrong: 18,
  bodyXLargeRegularStrikethrough: 18,
  bodyXLargeStrongStrikethrough: 18,
  bodyLargeRegular: 16,
  bodyLargeStrong: 16,
  bodyLargeRegularStrikethrough: 16,
  bodyLargeStrongStrikethrough: 16,
  bodyMediumRegular: 14,
  bodyMediumStrong: 14,
  bodyMediumRegularStrikethrough: 14,
  bodyMediumStrongStrikethrough: 14,
  bodySmallRegular: 12,
  bodySmallStrong: 12,
  bodySmallRegularStrikethrough: 12,
  bodySmallStrongStrikethrough: 12,
  bodyXSmallRegular: 10,
  bodyXSmallStrong: 10,
  bodyXSmallRegularStrikethrough: 10,
  bodyXSmallStrongStrikethrough: 10,
  buttonLargeRegular: 16,
  buttonLargeStrong: 16,
  buttonMediumRegular: 14,
  buttonMediumStrong: 14,
  buttonSmallRegular: 12,
  buttonSmallStrong: 12,
  buttonXSmallRegular: 10,
  buttonXSmallStrong: 10,
  metadataMedium: 12,
  metadataSmall: 10,
  labelXLarge: 16,
  labelLarge: 14,
  labelMedium: 12,
  labelSmall: 10,
  labelXSmall: 8,
};

export const letterSpacings = {
  letterSpacing010: 0,
  letterSpacing020: 0.5,
  letterSpacing030: 1,
  jumboXxLarge: 0,
  jumboXLarge: 0,
  jumboLarge: 0,
  jumboMedium: 0,
  jumboSmall: 0,
  headingXxLarge: 0,
  headingXLarge: 0,
  headingLarge: 0,
  headingMedium: 0,
  headingSmall: 0,
  headingXSmall: 0,
  bodyXLargeRegular: 0,
  bodyXLargeStrong: 0,
  bodyXLargeRegularStrikethrough: 0,
  bodyXLargeStrongStrikethrough: 0,
  bodyLargeRegular: 0,
  bodyLargeStrong: 0,
  bodyLargeRegularStrikethrough: 0,
  bodyLargeStrongStrikethrough: 0,
  bodyMediumRegular: 0,
  bodyMediumStrong: 0,
  bodyMediumRegularStrikethrough: 0,
  bodyMediumStrongStrikethrough: 0,
  bodySmallRegular: 0,
  bodySmallStrong: 0,
  bodySmallRegularStrikethrough: 0,
  bodySmallStrongStrikethrough: 0,
  bodyXSmallRegular: 0,
  bodyXSmallStrong: 0,
  bodyXSmallRegularStrikethrough: 0,
  bodyXSmallStrongStrikethrough: 0,
  buttonLargeRegular: 0,
  buttonLargeStrong: 0,
  buttonMediumRegular: 0,
  buttonMediumStrong: 0,
  buttonSmallRegular: 0,
  buttonSmallStrong: 0,
  buttonXSmallRegular: 0,
  buttonXSmallStrong: 0,
  metadataMedium: 1,
  metadataSmall: 1,
  labelXLarge: 1,
  labelLarge: 1,
  labelMedium: 1,
  labelSmall: 1,
  labelXSmall: 1,
};

export const textCase = {
  textCaseUppercase: "uppercase",
  textCaseCapitalize: "capitalize",
  textCaseLowercase: "lowercase",
  textCaseNone: "none",
  jumboXxLarge: "none",
  jumboXLarge: "none",
  jumboLarge: "none",
  jumboMedium: "none",
  jumboSmall: "none",
  headingXxLarge: "none",
  headingXLarge: "none",
  headingLarge: "none",
  headingMedium: "none",
  headingSmall: "none",
  headingXSmall: "none",
  bodyXLargeRegular: "none",
  bodyXLargeStrong: "none",
  bodyXLargeRegularStrikethrough: "none",
  bodyXLargeStrongStrikethrough: "none",
  bodyLargeRegular: "none",
  bodyLargeStrong: "none",
  bodyLargeRegularStrikethrough: "none",
  bodyLargeStrongStrikethrough: "none",
  bodyMediumRegular: "none",
  bodyMediumStrong: "none",
  bodyMediumRegularStrikethrough: "none",
  bodyMediumStrongStrikethrough: "none",
  bodySmallRegular: "none",
  bodySmallStrong: "none",
  bodySmallRegularStrikethrough: "none",
  bodySmallStrongStrikethrough: "none",
  bodyXSmallRegular: "none",
  bodyXSmallStrong: "none",
  bodyXSmallRegularStrikethrough: "none",
  bodyXSmallStrongStrikethrough: "none",
  buttonLargeRegular: "none",
  buttonLargeStrong: "none",
  buttonMediumRegular: "none",
  buttonMediumStrong: "none",
  buttonSmallRegular: "none",
  buttonSmallStrong: "none",
  buttonXSmallRegular: "none",
  buttonXSmallStrong: "none",
  metadataMedium: "uppercase",
  metadataSmall: "uppercase",
  labelXLarge: "uppercase",
  labelLarge: "uppercase",
  labelMedium: "uppercase",
  labelSmall: "uppercase",
  labelXSmall: "uppercase",
};

export const textDecoration = {
  textDecorationNone: "none",
  textDecorationUnderline: "underline",
  textDecorationLineThrough: "line-through",
  jumboXxLarge: "none",
  jumboXLarge: "none",
  jumboLarge: "none",
  jumboMedium: "none",
  jumboSmall: "none",
  headingXxLarge: "none",
  headingXLarge: "none",
  headingLarge: "none",
  headingMedium: "none",
  headingSmall: "none",
  headingXSmall: "none",
  bodyXLargeRegular: "none",
  bodyXLargeStrong: "none",
  bodyXLargeRegularStrikethrough: "line-through",
  bodyXLargeStrongStrikethrough: "line-through",
  bodyLargeRegular: "none",
  bodyLargeStrong: "none",
  bodyLargeRegularStrikethrough: "line-through",
  bodyLargeStrongStrikethrough: "line-through",
  bodyMediumRegular: "none",
  bodyMediumStrong: "none",
  bodyMediumRegularStrikethrough: "line-through",
  bodyMediumStrongStrikethrough: "line-through",
  bodySmallRegular: "none",
  bodySmallStrong: "none",
  bodySmallRegularStrikethrough: "line-through",
  bodySmallStrongStrikethrough: "line-through",
  bodyXSmallRegular: "none",
  bodyXSmallStrong: "none",
  bodyXSmallRegularStrikethrough: "line-through",
  bodyXSmallStrongStrikethrough: "line-through",
  buttonLargeRegular: "none",
  buttonLargeStrong: "none",
  buttonMediumRegular: "none",
  buttonMediumStrong: "none",
  buttonSmallRegular: "none",
  buttonSmallStrong: "none",
  buttonXSmallRegular: "none",
  buttonXSmallStrong: "none",
  metadataMedium: "none",
  metadataSmall: "none",
  labelXLarge: "none",
  labelLarge: "none",
  labelMedium: "none",
  labelSmall: "none",
  labelXSmall: "none",
};

export const sizes = {
  maxContentWidth: 1400,
};

export const space = {
  spaceBase: 4,
  space0: 0,
  space025: 1,
  space05: 2,
  space1: 4,
  space2: 8,
  space3: 12,
  space4: 16,
  space5: 20,
  space6: 24,
  space8: 32,
  space10: 40,
  space12: 48,
  space16: 64,
  space20: 80,
  space30: 120,
  space40: 160,
};

export const shadows = {
  elevationsTopLow: "0px -2px 4px 0px rgba(10, 10, 10, 0.1)",
  elevationsTopMid: "0px -4px 8px 0px rgba(10, 10, 10, 0.2)",
  elevationsTopHigh: "0px -8px 16px 0px rgba(10, 10, 10, 0.3)",
  elevationsBottomLow: "0px 2px 4px 0px rgba(10, 10, 10, 0.1)",
  elevationsBottomMid: "0px 4px 8px 0px rgba(10, 10, 10, 0.2)",
  elevationsBottomHigh: "0px 8px 16px 0px rgba(10, 10, 10, 0.3)",
  elevationsAllAroundLow: "0px 0px 4px 2px rgba(10, 10, 10, 0.1)",
  elevationsAllAroundMid: "0px 0px 8px 2px rgba(10, 10, 10, 0.2)",
  elevationsAllAroundHigh: "0px 0px 16px 2px rgba(10, 10, 10, 0.3)",
};

export const borderWidths = {
  borderWidthDefault: 1,
  borderWidth000: 0,
  borderWidth010: 1,
  borderWidth020: 2,
  borderWidth030: 4,
  borderWidth040: 8,
};

export const radii = {
  borderRadiusDefault: 4,
  borderRadiusSharp: 0,
  borderRadiusCircle: 9999,
  borderRadiusRounded: 8,
  borderRadius010: 2,
  borderRadius020: 4,
  borderRadius030: 8,
  borderRadius040: 12,
  borderRadius050: 24,
  componentButtonCornerRadius: 4,
  componentDataInputCornerRadius: 4,
  componentPillCornerRadius: 9999,
  componentCardCornerRadius: 4,
};

export const borderStyles = {
  borderStyleSolidStyle: "solid",
  borderStyleDashedStyle: "dashed",
};

export const paragraphSpacing = {
  jumboXxLarge: "",
  jumboXLarge: "",
  jumboLarge: "",
  jumboMedium: "",
  jumboSmall: "",
  headingXxLarge: "",
  headingXLarge: "",
  headingLarge: "",
  headingMedium: "",
  headingSmall: "",
  headingXSmall: "",
  bodyXLargeRegular: "",
  bodyXLargeStrong: "",
  bodyXLargeRegularStrikethrough: "",
  bodyXLargeStrongStrikethrough: "",
  bodyLargeRegular: "",
  bodyLargeStrong: "",
  bodyLargeRegularStrikethrough: "",
  bodyLargeStrongStrikethrough: "",
  bodyMediumRegular: "",
  bodyMediumStrong: "",
  bodyMediumRegularStrikethrough: "",
  bodyMediumStrongStrikethrough: "",
  bodySmallRegular: "",
  bodySmallStrong: "",
  bodySmallRegularStrikethrough: "",
  bodySmallStrongStrikethrough: "",
  bodyXSmallRegular: "",
  bodyXSmallStrong: "",
  bodyXSmallRegularStrikethrough: "",
  bodyXSmallStrongStrikethrough: "",
  buttonLargeRegular: "",
  buttonLargeStrong: "",
  buttonMediumRegular: "",
  buttonMediumStrong: "",
  buttonSmallRegular: "",
  buttonSmallStrong: "",
  buttonXSmallRegular: "",
  buttonXSmallStrong: "",
  metadataMedium: "",
  metadataSmall: "",
  labelXLarge: "",
  labelLarge: "",
  labelMedium: "",
  labelSmall: "",
  labelXSmall: "",
};

export const text = {
  themeName: "Fanduel Light",
};

export const nativeShadows = {
  elevationsTopLow: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.1,
      offset: {
        height: -2,
        width: 0,
      },
      radius: 4,
      spread: 0,
      css: "0px -2px 4px 0px rgba(10, 10, 10, 0.1)",
    },
  ],
  elevationsTopMid: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.2,
      offset: {
        height: -4,
        width: 0,
      },
      radius: 8,
      spread: 0,
      css: "0px -4px 8px 0px rgba(10, 10, 10, 0.2)",
    },
  ],
  elevationsTopHigh: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.3,
      offset: {
        height: -8,
        width: 0,
      },
      radius: 16,
      spread: 0,
      css: "0px -8px 16px 0px rgba(10, 10, 10, 0.3)",
    },
  ],
  elevationsBottomLow: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.1,
      offset: {
        height: 2,
        width: 0,
      },
      radius: 4,
      spread: 0,
      css: "0px 2px 4px 0px rgba(10, 10, 10, 0.1)",
    },
  ],
  elevationsBottomMid: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.2,
      offset: {
        height: 4,
        width: 0,
      },
      radius: 8,
      spread: 0,
      css: "0px 4px 8px 0px rgba(10, 10, 10, 0.2)",
    },
  ],
  elevationsBottomHigh: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.3,
      offset: {
        height: 8,
        width: 0,
      },
      radius: 16,
      spread: 0,
      css: "0px 8px 16px 0px rgba(10, 10, 10, 0.3)",
    },
  ],
  elevationsAllAroundLow: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.1,
      offset: {
        height: 0,
        width: 0,
      },
      radius: 4,
      spread: 2,
      css: "0px 0px 4px 2px rgba(10, 10, 10, 0.1)",
    },
  ],
  elevationsAllAroundMid: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.2,
      offset: {
        height: 0,
        width: 0,
      },
      radius: 8,
      spread: 2,
      css: "0px 0px 8px 2px rgba(10, 10, 10, 0.2)",
    },
  ],
  elevationsAllAroundHigh: [
    {
      type: "dropShadow",
      color: "#0a0a0a",
      opacity: 0.3,
      offset: {
        height: 0,
        width: 0,
      },
      radius: 16,
      spread: 2,
      css: "0px 0px 16px 2px rgba(10, 10, 10, 0.3)",
    },
  ],
};